import {
  normalizeGenerationErrorCode,
  normalizeGenerationFailurePhase,
} from "./generation-error";

export type FunnelEventProperties = Record<string, string | number | boolean | readonly string[] | null | undefined>;

export type PersistableFunnelProperty = string | number | boolean | readonly string[] | null;
export type PersistableFunnelProperties = Record<string, PersistableFunnelProperty>;

const SENSITIVE_PROPERTY_PATTERNS = [
  /email/i,
  /phone/i,
  /name/i,
  /address/i,
  /image/i,
  /url/i,
  /session/i,
  /token/i,
  /secret/i,
  /customer/i,
  /stripe/i,
  /order[_-]?id/i,
];

const GENERATION_FAILURE_CONTEXT_KEYS = [
  "style",
  "subStyle",
  "formatSize",
  "aspectRatio",
  "attempts",
  "durationSeconds",
] as const;

export function sanitizeFunnelProperties(
  properties: FunnelEventProperties = {},
  eventName?: string,
): PersistableFunnelProperties {
  const sanitized = Object.fromEntries(
    Object.entries(properties).filter(([key, value]) => {
      if (value === undefined) return false;
      return !SENSITIVE_PROPERTY_PATTERNS.some((pattern) => pattern.test(key));
    }),
  ) as PersistableFunnelProperties;

  if (eventName !== "generation_failed") return sanitized;

  const generationFailure: PersistableFunnelProperties = {
    errorCode: normalizeGenerationErrorCode(sanitized.errorCode),
  };
  for (const key of GENERATION_FAILURE_CONTEXT_KEYS) {
    if (key in sanitized) generationFailure[key] = sanitized[key]!;
  }
  if (typeof sanitized.creditsRefunded === "boolean") {
    generationFailure.creditsRefunded = sanitized.creditsRefunded;
  }
  if (typeof sanitized.retryable === "boolean") {
    generationFailure.retryable = sanitized.retryable;
  }
  const phase = normalizeGenerationFailurePhase(sanitized.phase);
  if (phase) generationFailure.phase = phase;

  return generationFailure;
}
